import { useState } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Button } from '@/shared/ui'

import styles from './PromotionBottomDescription.module.scss'

export type PromotionBottomDescriptionProps = {
	description: string
	title?: string
}

export const PromotionBottomDescription = ({ description, title }: PromotionBottomDescriptionProps): JSX.Element => {
	const [isOpen, setIsOpen] = useState<boolean>(true)
	const textClassName = [styles.text]
	if (!isOpen) textClassName.push(styles.text_closed)

	return (
		<div className={styles.promotionBottomDescription}>
			{title && <h3 className={styles.descriptionTitle} dangerouslySetInnerHTML={createMarkup(title)} />}
			<span className={textClassName.join(' ')} dangerouslySetInnerHTML={createMarkup(description)} />
			<Button onClick={() => setIsOpen(!isOpen)}>{isOpen ? `Спрятать` : `Показать`}</Button>
		</div>
	)
}
